var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('Main'),_c('div',{staticClass:"main main-raised"},[_c('Haus'),_c('Greetsiel'),_c('Galerie'),_c('Lage'),_c('Kontakt')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }